import { createContext, useContext } from 'react'

/**
 * Lets any descendant (e.g. the mobile header burger, or a full-screen page that covers the header)
 * open the mobile navigation drawer owned by MasterLayout. No-op default so consumers render safely
 * outside a provider (tests, storybook).
 */
export const MobileNavContext = createContext<{ openMobileNav: () => void }>({ openMobileNav: () => {} })

export const useMobileNav = () => useContext(MobileNavContext)
